<template>
  <div style="height: 100%;">
    <k-data-table fill-height :headers="headers_list" :items="channelList" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      
      <template slot="headerCell" slot-scope="props">
          <div v-if="props.header.text == 'State'">
            <k-menu offset-y :close-on-content-click="false">
                <template slot="activator" slot-scope="{ on }" style="padding: 20px;">
                    <k-btn flat v-on="on">
                    <span style="display: flex; align-items: center;">
                      <div style="margin-right: 25px; margin-left: 35px;">State</div>
                      <k-icon small>filter_list</k-icon>
                    </span>
                    </k-btn>
                </template>
                <template #default>
                  <div style="padding: 0px; margin: 0px;">
                      <k-checkbox
                        v-model="state_filters"
                        label="Active"
                        input-value="active"
                        color="deep-orange"
                        style="padding: 0px; margin: 0px; height: 28px;"
                        hide-details
                      ></k-checkbox>
                  </div>
                  <div style="padding: 0px; margin: 0px;">
                      <k-checkbox
                        v-model="state_filters"
                        label="Archived"
                        input-value="archived"
                        color="deep-orange"
                        style="padding: 0px; margin: 0px; height: 28px;"
                        hide-details
                      ></k-checkbox>
                  </div>
                </template>
            </k-menu>

          </div>

          <span v-else>
              <td>{{ props.header.text }}</td>
          </span>
      </template>

      <template slot="items" slot-scope="props">
        <tr>
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.title }}</td>
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.name }}</td>
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.uuid }}</td>
        <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.state }}</td>


        <template v-if="props.item.type == 'input'">
          <td @click.stop="open_edit_hannel(props.item.uuid)" :class="if_archived_color(props.item.state)">
            <span v-for="alternative in get_alternatives(props.item)" class="alternative-title">
              {{alternative}}
            </span>
          </td>
        </template>


        <template v-if="props.item.type == 'output'">
          <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">
            <k-icon small no-margin v-if="props.item.transcoder">check</k-icon>
          </td>
          <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.meta.transcoder_config }}</td>
          <td @click.stop="open_edit_channel(props.item.uuid)" :class="if_archived_color(props.item.state)">{{ props.item.meta.transcoder_size }}</td>
        </template>
        </tr>
      </template>
    
    </k-data-table>
<!--    <action-buttons v-if="$is_admin()" @add="open_add_channel"></action-buttons>-->
  </div>
</template>

<script>

import ChannelModel from '@/models/channel.js';
import ActionButtons from '@/components/ActionButtons.vue'

export default {
  components: {
    ActionButtons
  },
  props: ['type'],
  data () {
    return {
      headers: [
        { text: 'Title', value: 'title', align: 'left' },
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Uuid', value: 'uuid', align: 'left' },
        { text: 'State', value: 'state', align: 'left', sortable: false }
      ],
      input_headers: [
        { text: "Alternatives", value: "alternatives", align: "left"},
      ],
      output_headers: [
        { text: 'Transcoder', value: 'transcoder', align: 'left' },
        { text: 'Transcoder config', value: 'transcoder_config', align: 'left' },
        { text: 'Transcoder size', value: 'transcoder_size', align: 'left' }
      ],
      pagination: {
        sortBy: 'title',
        descending: true,
        rowsPerPage: 25
      },
      state_filters: ['active'],
      search_text: ""
    }
  },
  computed: {
/*    search_text () {
      return this.$store.state.search_text;
    },*/
    headers_list () {
      if (this.type == "outputs") {
        return this.headers.concat(this.output_headers);        
      }
      if (this.type == "inputs") {
        return this.headers.concat(this.input_headers);
      }
      return this.headers;
    },
    channelList () {
      var ret = [];
      var self = this;
      var search = (this.search_text || "").toLowerCase();
      if(this.type == "inputs") {
        ret = this.$store.getters.input_channels
      } else if(this.type == "outputs") {
        ret = this.$store.getters.output_channels
      }
      if(this.state_filters.length > 0) {
        ret = _.filter(ret, (channel) => {
          return this.state_filters.indexOf(channel.state) != -1;
        });
      }
      if (search.length > 0) {
        ret = _.filter(ret, function(channel) {
          ret = false;
          if (channel.title.toLowerCase().includes(search)) ret = true;
          if (channel.name.toLowerCase().includes(search)) ret = true;
          if (channel.uuid.toLowerCase().includes(search)) ret = true;
          if (self.type == "outputs") {
            if ((channel.meta.transcoder_config || "").toLowerCase().includes(search)) ret = true;
            if ((channel.meta.transcoder_size || "").toLowerCase().includes(search)) ret = true;
          }
          return ret;
        })
      }
      return ret;
    }
  },
  mounted () {
    this.$root.$on("channels:add", this.open_add_channel);
    this.$root.$on("channels:search", (search_text) => {
      this.search_text = search_text;
    });
  },
  beforeDestroy() {
    this.$root.$off("channels:add", this.open_add_channel);
    this.$root.$off("channels:search");
  },
  methods: {
    get_alternatives (channel) {
      var alternatives = ChannelModel.get_alternatives(channel);
      return _.map(alternatives, (alternative) => {
        return ChannelModel.get_alternative_title(alternative, channel);
      });
    },

    if_archived_color(state) {
      return state == 'archived' ? this.$dark() ? 'grey darken-2 grey--text' : 'grey lighten-4' : ''
    },
    open_add_channel () {
      if (!this.$is_admin()) {
        return;
      }
      this.$router.push("/channels/"+this.type+"/new")
    },
    open_edit_channel (uuid) {
      if (!this.$is_admin()) {
        return;
      }
      this.$router.push("/channels/"+this.type+"/edit/"+uuid)
    }
  }
}
</script>
